import Repository from './Repository';
const all_posts_resource = 'posts/all_posts';
const new_post_resource = 'posts/create_post';
const delete_post_resource = 'posts/delete_post_of_user';
const edit_post_resource = 'posts/edit_post';
const posts_comments_resource = 'posts/comments_by_posts';
const post_sale_status = 'posts/update_Sale_Status';
const notification_status = 'posts/notification_viewed';
const post_search_resouce = 'posts/posts_search_filter';


const new_likes_resource = 'likes/create_like';
const delete_likes_resource = 'likes/delete_like';

const new_comments_resource = 'comments/create_comment/';
const delete_comments_resource = 'comments/delete_comment';
const create_comment_reply_resource = 'comments/create_comment_reply';
const delete_comment_reply_resource = 'comments/delete_comment_reply';


export default {
  all_posts() {
    return Repository.get(`${all_posts_resource}`);
  },
  search_post(payload) {
    return Repository.post(`${post_search_resouce}`,payload);
  },
  new_post(payload) {
    return Repository.post(`${new_post_resource}`,payload);
  },
  
  update_notification_status(payload){
    return Repository.post(`${notification_status}`,payload);
  },
  update_post(payload){
    return Repository.post(`${edit_post_resource}`,payload);
  },
  remove_post(payload){
    return Repository.post(`${delete_post_resource}`,payload);
  },
  //Comments API
  change_sale_status(payload){
    return Repository.post(`${post_sale_status}`,payload);
  },
  new_comments(payload){
    return Repository.post(`${new_comments_resource}`,payload);
  },
  delete_comments(payload){
    return Repository.post(`${delete_comments_resource}`,payload);
  },
  //Likes API
  new_likes(payload){
    return Repository.post(`${new_likes_resource}`,payload);
  },
  remove_likes(payload){
    return Repository.post(`${delete_likes_resource}`,payload);
  },
  //Comments Posts API
  post_comments(payload) {
    return Repository.post(`${posts_comments_resource}`,payload);
  }, 
  createCommentReply(payload){
    return Repository.post(`${create_comment_reply_resource}`, payload)
  },
  deleteCommentReply(payload){
    return Repository.post(`${delete_comment_reply_resource}`, payload)
  }
  
  
};
